import { ModalProps } from './types';

export const styles = {
  overlay: 'tw-fixed tw-inset-0 tw-z-50 tw-bg-black tw-bg-opacity-50 tw-backdrop-blur-sm tw-flex',
  overlayCenter: 'tw-items-center tw-justify-center',
  overlaySide: 'tw-items-stretch tw-justify-end tw-p-0',
  container: 'tw-bg-white tw-shadow-xl tw-flex tw-flex-col tw-overflow-hidden',
  containerDefault: 'tw-rounded tw-max-h-[90vh] tw-w-full',
  containerSide: 'tw-h-full tw-max-h-full tw-rounded-none tw-rounded-l tw-min-w-0 tw-w-[50vw] tw-max-w-[50vw]',
  header: 'tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-4 tw-border-b tw-border-neutral-200',
  title: 'tw-text-lg tw-font-semibold tw-text-neutral-900 tw-m-0',
  closeButton: 'tw-w-5 tw-h-5',
  body: 'tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-px-6 tw-py-4',
  bodyDefault: 'tw-max-h-[60vh]',
  bodySide: 'tw-max-h-none',
  footer: 'tw-flex tw-items-center tw-justify-end tw-gap-3 tw-px-6 tw-py-4 tw-border-t tw-border-neutral-200 tw-bg-neutral-50',
};

export const sizeStyles: Record<NonNullable<ModalProps['size']>, string> = {
  sm: 'tw-max-w-sm',
  md: 'tw-max-w-md',
  lg: 'tw-max-w-lg',
  xl: 'tw-max-w-xl',
  '50vw': 'tw-w-[50vw] tw-max-w-[50vw]',
};
